import actionsTypes from '../constants/ActionsTypes';

const INITIAL_STATE = {
  clicked: { number: -1, index: -1 },
  clicked2: { number: -1, index: -1 },
  opcoes: [],
  opcoesDivididas: [],
  indexOpcoesDivididas: 0,
  finished: false
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actionsTypes.SET_MATCH_STATE:
      return {
        ...action.state
      };

    default:
      return state;
  }
}
